import PropTypes from 'prop-types';
import css from './ViewAllPhotos.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ViewAllPhotos = function ViewAllPhotos(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs("button", {
    "aria-label": "Click to view dialog with all photos",
    className: css.root,
    onClick: onClick,
    children: [/*#__PURE__*/_jsxs("div", {
      "aria-hidden": "true",
      className: css.rectangles,
      role: "presentation",
      children: [/*#__PURE__*/_jsx("i", {
        className: css.rectangle
      }), /*#__PURE__*/_jsx("i", {
        className: css.rectangle
      }), /*#__PURE__*/_jsx("i", {
        className: css.rectangle
      }), /*#__PURE__*/_jsx("i", {
        className: css.rectangle
      })]
    }), "View All Photos"]
  });
};

ViewAllPhotos.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default ViewAllPhotos;